import Vue from 'vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/nb';
import "@/assets/css/datepicker.scss";

Vue.use(DatePicker)
